export const BETTIE_QUERY_KEYS = {
  bettieBalances: ['bettieBalances']
};
